var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import axios from "axios";
import Qs from "qs";
import app from "~/config/app.config";
import store from "~/store";
import { Observable, empty } from "rxjs";
import { StorageService } from "~/utils/storage.service";
import { SortService } from "~/utils/sort.service";
import { MessageBox, Loading, Notification } from "element-ui";
import router from "~/router";
import NProgress from "nprogress";
var getType = ["GET", "DELETE"]; // 使用GET请求类型
var errorMessage = {
    systemError: "系统异常，请稍后重试.",
    serverError: "服务端异常,请稍后重试.",
    netError: "服务端连接异常，请检查服务端状态."
};
var NetService = /** @class */ (function () {
    function NetService() {
        this.loading = {};
        this.axiosInstance = axios.create({
            baseURL: app.url.server,
            timeout: app.timeout,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            }
        });
    }
    NetService.generateRequestUrl = function (_a, append, sort) {
        var service = _a.service, controller = _a.controller, action = _a.action, url = _a.url;
        // 自定义url优先级最高
        if (url)
            return url;
        // 进行url拼接
        if (controller) {
            var $appends = [];
            if (append) {
                $appends = typeof append === "string" ? [append] : append;
            }
            var targetUrl = __spreadArrays([service, "api", controller, action], $appends).filter(function (x) { return x; })
                .join("/");
            // 开启排序
            if (sort) {
                targetUrl += "?" + SortService.stringify(sort);
            }
            return targetUrl;
        }
        else {
            throw new Error("server配置异常,请检查对应server配置");
        }
    };
    /**
     * 发送网络请求信息
     * @param param0
     */
    NetService.prototype.send = function (options) {
        var _this = this;
        var data = __assign({}, options.data);
        var postData;
        var getData;
        var url = NetService.generateRequestUrl(options.server, options.append, options.sort);
        var method = options.server.type || "GET";
        var headers = this.generateRequestHeader(options.headers);
        // 分页检测
        if (options.page) {
            data = __assign(__assign({}, data), options.page.getConfig());
        }
        // 判断参数类型
        getType.indexOf(method) > -1
            ? (getData = this.filterEmptyData(data))
            : (postData = data);
        if (options.loading) {
            this.loading = Loading.service({
                fullscreen: true,
                lock: true,
                text: ""
            });
        }
        // 创建待观察对象
        var observable = Observable.create(function (observer) {
            NProgress.start();
            _this.axiosInstance
                .request({
                method: method,
                url: url,
                headers: headers,
                data: postData,
                params: getData,
                paramsSerializer: function (params) {
                    return Qs.stringify(params, {
                        arrayFormat: "repeat",
                        skipNulls: true,
                        allowDots: true
                    });
                }
            })
                .then(function (_a) {
                var data = _a.data;
                NProgress.done();
                // 分页数据处理
                if (options.page && data.content) {
                    options.page.update(data);
                    data = data.content;
                }
                // 关闭等待
                if (options.loading) {
                    setTimeout(function () {
                        _this.loading.close();
                    }, 500);
                }
                observer.next(data);
            })
                .catch(_this.catchHandle(options, observer));
        });
        return observable;
    };
    /**
     * 生成头部信息
     */
    NetService.prototype.generateRequestHeader = function (headers) {
        var token = StorageService.getItem("userToken") || "";
        if (token) {
            return __assign({ "X-UserToken": token }, headers);
        }
        else {
            return headers || {};
        }
    };
    /**
     * 过滤空数据
     * @param data
     */
    NetService.prototype.filterEmptyData = function (data) {
        Object.entries(data)
            .filter(function (_a) {
            var key = _a[0], value = _a[1];
            // 过滤空字符串
            if (value === undefined || value === "") {
                return true;
            }
            // 过滤空数组
            if (value instanceof Array &&
                (value.length === 0 || value.every(function (x) { return x === ""; }))) {
                return true;
            }
        })
            .forEach(function (_a) {
            var key = _a[0], value = _a[1];
            delete data[key];
        });
        return data;
    };
    /**
     * 异常处理
     */
    NetService.prototype.catchHandle = function (options, observer) {
        var _this = this;
        NProgress.done();
        return function (ex) {
            // 错误信息
            if (!ex.response) {
                Notification.error(errorMessage.netError);
                return empty();
            }
            var error = {
                msg: "",
                params: "",
                data: ex.response.data
            };
            if (options.loading) {
                setTimeout(function () {
                    _this.loading.close();
                }, 500);
            }
            // 逻辑异常检测
            if (!ex.response && !ex.request) {
                error.msg = ex.message;
                error.params = ex.stack;
                console.error(ex.stack);
                Notification.error(errorMessage.systemError);
                return empty();
            }
            // 网络异常检测
            if (!ex.response && ex.request) {
                error.msg = errorMessage.netError;
            }
            if (ex.response) {
                error.msg = errorMessage.netError;
                // 错误类型检测
                switch (ex.response.status) {
                    case 400: {
                        if (options.server.action === 'getUserByToken') {
                            MessageBox.alert("用户登录过期,请重新登录", "提示", {
                                confirmButtonText: "确定",
                                callback: function () {
                                    router.push("/");
                                }
                            });
                            return;
                        }
                        var data = ex.response.data || {};
                        error.msg = "";
                        data.errors.forEach(function (x) {
                            if (x.defaultMessage) {
                                Notification.error(x.defaultMessage);
                            }
                        });
                        error.params = data.errors.join(";");
                        break;
                    }
                    case 403: {
                        if (!store.state.tokenExpire) {
                            store.commit("updateTokenExpire", true);
                        }
                        else {
                            break;
                        }
                        if (!options.skipAuth) {
                            MessageBox.alert("用户登录过期,请重新登录", "提示", {
                                confirmButtonText: "确定",
                                callback: function () {
                                    router.push("/");
                                }
                            });
                            return;
                        }
                    }
                    case 500: {
                        Notification.error(errorMessage.serverError);
                        break;
                    }
                }
            }
            observer.error(error);
        };
    };
    return NetService;
}());
export { NetService };
